<template>
  <div class="overflow-x-auto rounded-lg border border-gray-200">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-slate-50">
        <tr>
          <th class="px-4 py-3 w-10"></th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Size
          </th>
          <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
            Specification
          </th>
          <th class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            Price
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr
          v-for="entry in entries"
          :key="entry.type"
          class="cursor-pointer hover:bg-slate-50 transition-colors"
          :class="isSelected(entry) ? 'bg-indigo-50' : ''"
          @click="$emit('select', entry)"
        >
          <td class="px-4 py-3">
            <span
              class="h-4 w-4 rounded-full flex items-center justify-center ring-2 ring-offset-2"
              :class="isSelected(entry) ? 'bg-indigo-600 ring-indigo-300' : 'bg-white ring-gray-300'"
            >
              <span v-if="isSelected(entry)" class="h-1.5 w-1.5 rounded-full bg-white"></span>
            </span>
          </td>
          <td class="px-4 py-3 text-sm font-medium text-gray-900 whitespace-nowrap">
            {{ entry.type }}
          </td>
          <td class="px-4 py-3 text-sm text-gray-600">{{ entry.spec || entry.description || "—" }}</td>
          <td class="px-4 py-3 text-sm font-medium text-gray-900 text-right whitespace-nowrap">
            <span v-currency="entry.price">{{ entry.price }}</span>
            <span class="text-xs text-gray-500 ml-1">/{{ entry.unit }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "InstancePicker",
  props: {
    entries: { type: Array, default: () => [] },
    selected: { type: Object, default: null },
  },
  emits: ["select"],
  methods: {
    isSelected(entry) {
      return this.selected && this.selected.type === entry.type;
    },
  },
};
</script>
